import axios from 'axios';
import { setCompanyTokenExhausted } from '../store/slices/companySlice';
import { setCandidateTokenExhausted } from '../store/slices/candidateSlice';
import { setTokenExhausted } from '../store/slices/authSlice';

export const axiosMiddleware = (store: any) => {
  // Redux calls this creator function once when the store is built, so
  // registering the interceptor here (not inside the returned per-action
  // handler below) registers it exactly once instead of once per dispatch.
  setInterceptors(store);

  return (next: any) => (action: any) => next(action);
};

export const setInterceptors = (store: any) => {
  if (!store) {
    return;
  }

  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      const { dispatch } = store;

      // error.response is undefined for network errors/timeouts, where
      // there's no status code to act on.
      if (error.response) {
        // 403 token exhausted
        if (error.response.status === 403) {
          dispatch(setCandidateTokenExhausted(true));
          dispatch(setCompanyTokenExhausted(true));
          dispatch(setTokenExhausted(true));
        }
        //  401 no token in local storage
        if (error.response.status === 401) {
          dispatch(setTokenExhausted(true));
        }
      }
      return Promise.reject(error);
    }
  );
};
